import { AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import { AutomationRulesTriggersType } from 'modules/automation-rules/triggers/types/automation-rule-trigger-interface'
import { AutomationRulesTriggersEditType } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface'
import { StoreTriggerDataInterface } from './fill-trigger-with-store-data'

export const splitRelatedAndUnrelatedTriggers = <
  T extends AutomationRulesTriggersEditType | AutomationRulesTriggersType,
>(
  triggers: Array<T>,
  storeItemId?: StoreTriggerDataInterface['itemId'],
) => {
  const relatedTriggers: Array<T> = []
  const unrelatedTriggers: Array<T> = []
  triggers.forEach(trigger => {
    switch (trigger.type) {
      case AutomationRuleTriggersEnum.digital_store_form_subscribed:
        trigger.itemOptIn.id === storeItemId
          ? relatedTriggers.push(trigger)
          : unrelatedTriggers.push(trigger)
        break
      default:
        unrelatedTriggers.push(trigger)
    }
  })

  return { relatedTriggers, unrelatedTriggers }
}
